/*// Product names and their corresponding image URLs from Shopify assets
const productImages = {
  'Pillar Green': 'https://www.stotodo.com/cdn/shop/files/76_20241022_141114_0075.jpg?v=1729590874&width=1426',
  'Tank Green': 'https://www.stotodo.com/cdn/shop/files/Product_page_slideshow_20241028_130511_0000.jpg?v=1730111666&width=1426',
  'Droid Black': 'https://www.stotodo.com/cdn/shop/files/Dimensions_20241028_114136_0000.jpg?v=1730097082&width=1426',
  'Tank Black': 'https://www.stotodo.com/cdn/shop/files/52_20241022_141113_0051.jpg?v=1729590657&width=1426',
  'Pillar Grey': 'https://www.stotodo.com/cdn/shop/files/77_20241022_141114_0076.jpg?v=1729590874&width=1426',
  'Tank White': 'https://www.stotodo.com/cdn/shop/files/51_20241022_141113_0050.jpg?v=1729590657&width=1426',
  'Droid Cream': 'https://www.stotodo.com/cdn/shop/files/Dimensions_20241022_172421_0000.jpg?v=1729615222&width=1426',
  // Add more products as needed
};

// Function to load customer data
async function loadCustomerData() {
  try {
    // Get the URL from the data-attribute in the DOM
    const url = document.getElementById('customer-data').getAttribute('data-json-url');
    console.log('Fetching customer data from:', url);  // Log the URL to verify it's correct

    const response = await fetch(url);
    if (response.ok) {
      const data = await response.json();
      console.log('Customer data loaded:', data);  // Log the data to check if it's loading correctly
      return data;
    } else {
      console.error('Failed to load customer data. Response:', response);
      return [];
    }
  } catch (err) {
    console.error('Error loading customer data:', err);  // Log any errors that occur
    return [];
  }
}

// Function to generate a random time in hours/days for notification display
function getRandomTimeAgo() {
  const randomMinutes = Math.floor(Math.random() * 30) + 1; // Random value between 1 and 30 minutes
  return `${randomMinutes} minutes ago`;
}

// Generate a random notification message from customer and product data
function generateRandomNotification(customerData, productNames) {
  const customer = customerData[Math.floor(Math.random() * customerData.length)];
  const product = productNames[Math.floor(Math.random() * productNames.length)];
  const timeAgo = getRandomTimeAgo();

  return {
    message: `${customer.firstName} ${customer.lastInitial} from ${customer.city} bought ${product} ${timeAgo}`,
    image: productImages[product], // Fetch product image from the productImages object
  };
}

// Function to display notifications at random intervals
function displayDummyNotifications(customerData, productNames) {
  setInterval(() => {
    const { message, image } = generateRandomNotification(customerData, productNames);
    showNotification(message, image); // Pass image URL to the notification function
  }, Math.floor(Math.random() * 6000)); // Random interval up to 10 minutes (600,000 ms)
}

function showNotification(notificationText, imageUrl) {
  const notificationContainer = document.getElementById('notification-container');
  const notificationElement = document.createElement('div');
  notificationElement.className = 'notification';

  // Create an image element for the product
  const productImage = document.createElement('img');
  productImage.src = imageUrl;
  productImage.alt = 'Product Image';
  productImage.style.width = '50px'; // Adjust the size as needed
  productImage.style.height = '50px'; // Adjust the size as needed
  productImage.style.marginRight = '10px'; // Space between the image and text
  
  // Append the image and the message to the notification
  notificationElement.appendChild(productImage);
  notificationElement.appendChild(document.createTextNode(notificationText));

  // Basic styling for the notification
  notificationElement.style.cssText = `
    background-color: #fff;
    color: #38454f;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    font-size: 14px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
  `;

  notificationContainer.appendChild(notificationElement);

  // Remove the notification after 10 seconds
  setTimeout(() => {
    notificationElement.remove();
  }, 10000);
}
// Initialize the notifications by loading customer data and starting the display loop
async function initNotifications() {
  const customerData = await loadCustomerData();
  const productNames = [
    'Pillar Green',
    'Tank Green',
    'Droid Black',
    'Tank Black',
    'Pillar Grey',
    'Tank White',
    'Droid Cream',
    // Add all product names available on your site here
  ];

  if (customerData.length > 0) {
    displayDummyNotifications(customerData, productNames);
  }
}

// Run the notification initialization function
initNotifications();
*/

















// Product names and their corresponding image URLs from Shopify assets
const productImages = {
  'Pillar Green': 'https://www.stotodo.com/cdn/shop/files/76_20241022_141114_0075.jpg?v=1729590874&width=1426',
  'Tank Green': 'https://www.stotodo.com/cdn/shop/files/Product_page_slideshow_20241028_130511_0000.jpg?v=1730111666&width=1426',
  'Droid Black': 'https://www.stotodo.com/cdn/shop/files/Dimensions_20241028_114136_0000.jpg?v=1730097082&width=1426',
  'Tank Black': 'https://www.stotodo.com/cdn/shop/files/52_20241022_141113_0051.jpg?v=1729590657&width=1426',
  'Pillar Grey': 'https://www.stotodo.com/cdn/shop/files/77_20241022_141114_0076.jpg?v=1729590874&width=1426',
  'Tank White': 'https://www.stotodo.com/cdn/shop/files/51_20241022_141113_0050.jpg?v=1729590657&width=1426',
  'Droid Cream': 'https://www.stotodo.com/cdn/shop/files/Dimensions_20241022_172421_0000.jpg?v=1729615222&width=1426',
  'Carbon Premium Flask': 'https://www.stotodo.com/cdn/shop/files/77_20241121_233505_0000.jpg?v=1732252908&width=2200',
};

// Function to load customer data
async function loadCustomerData() {
  try {
    const url = document.getElementById('customer-data').getAttribute('data-json-url');
    const response = await fetch(url);
    if (response.ok) {
      return await response.json();
    } else {
      console.error('Failed to load customer data');
      return [];
    }
  } catch (err) {
    console.error('Error loading customer data:', err);
    return [];
  }
}

// Function to generate a random time in minutes
function getRandomTimeAgo() {
  const randomMinutes = Math.floor(Math.random() * 30) + 1;
  return `${randomMinutes} minutes ago`;
}

// Generate a random notification message
function generateRandomNotification(customerData, productNames) {
  const customer = customerData[Math.floor(Math.random() * customerData.length)];
  const product = productNames[Math.floor(Math.random() * productNames.length)];
  const timeAgo = getRandomTimeAgo();

  return {
    customerInfo: `${customer.firstName} ${customer.lastInitial}, ${customer.city}`,
    productInfo: `Bought ${product}`,
    timeAgo: timeAgo,
    image: productImages[product],
  };
}
/*
// Function to display notifications at random intervals
function displayDummyNotifications(customerData, productNames) {
  function showRandomNotification() {
    const { customerInfo, productInfo, timeAgo, image } = generateRandomNotification(customerData, productNames);
    showNotification(customerInfo, productInfo, timeAgo, image);

    // Set the next notification display time to a random interval between 1 to 10 minutes (60000 ms to 600000 ms)
    const randomInterval = Math.floor(Math.random() * 10 * 60 * 1000) + (1 * 60 * 1000);
    setTimeout(showRandomNotification, randomInterval);
  }

  // Start the first notification
  showRandomNotification();
}
*/

// Function to display notifications at random intervals, but only once on the first page load
function displayDummyNotifications(customerData, productNames) {
  function showRandomNotification() {
    const { customerInfo, productInfo, timeAgo, image } = generateRandomNotification(customerData, productNames);
    showNotification(customerInfo, productInfo, timeAgo, image);

    // Set the next notification display time to a random interval between 1 to 10 minutes
    const randomInterval = Math.floor(Math.random() * 4 * 60 * 1000) + (1 * 60 * 1000);
    setTimeout(showRandomNotification, randomInterval);
  }

  // Check if the notification has already been shown in this session
  if (!sessionStorage.getItem('notificationShown')) {
    // Show the notification for the first page load
    showRandomNotification();

    // Set the flag in sessionStorage to prevent showing again in this session
    sessionStorage.setItem('notificationShown', 'true');
  }
}



// Function to show the notification with the updated styling
function showNotification(customerInfo, productInfo, timeAgo, imageUrl) {
  const notificationContainer = document.getElementById('notification-container');
  const notificationElement = document.createElement('div');
  notificationElement.className = 'notification';

  const productImage = document.createElement('img');
  productImage.src = imageUrl;
  productImage.alt = 'Product Image';

  // Styling for product image
  productImage.style.cssText = `
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-right: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  `;

  // Container for text content
  const textContainer = document.createElement('div');
  textContainer.style.cssText = `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  `;

  // Customer info line
  const customerInfoLine = document.createElement('div');
  customerInfoLine.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  `;

  // Customer name and city with truncation for long names
  const customerText = document.createElement('span');
  customerText.innerHTML = `<span style="font-weight: bold; font-size: 14px; max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${customerInfo.split(',')[0]}</span>, <span style="font-weight: normal; font-size: 13px; color: rgba(0, 0, 0, 0.7);">${customerInfo.split(',')[1]}</span>`;

  // Product info line
  const productInfoLine = document.createElement('div');
  productInfoLine.innerHTML = `<span style="font-size: 13px;">${productInfo}</span>`;
  productInfoLine.style.cssText = `color: rgba(0, 0, 0, 0.8);`;

  // Time info
  const timeAgoText = document.createElement('span');
  timeAgoText.textContent = timeAgo;
  timeAgoText.style.cssText = `
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    font-style: italic;
    align-self: flex-end;
    margin-left: 15px;
  `;

  // Add elements to notification
  customerInfoLine.appendChild(customerText);
  customerInfoLine.appendChild(timeAgoText);
  textContainer.appendChild(customerInfoLine);
  textContainer.appendChild(productInfoLine);

  notificationElement.appendChild(productImage);
  notificationElement.appendChild(textContainer);

  // Styling for the notification itself
  notificationElement.style.cssText = `
    display: flex;
    align-items: center;
    background: #f4f4f4;
    color: #333;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
    font-size: 13px;
    font-family: Arial, sans-serif;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, opacity 0.3s ease;
    opacity: 0;
    transform: translateY(15px);
    max-width: 300px;
  `;

  setTimeout(() => {
    notificationElement.style.opacity = '1';
    notificationElement.style.transform = 'translateY(0)';
  }, 100);

  notificationContainer.appendChild(notificationElement);

  // Remove the notification after 10 seconds
  setTimeout(() => {
    notificationElement.style.opacity = '0';
    notificationElement.style.transform = 'translateY(15px)';
    setTimeout(() => notificationElement.remove(), 300);
  }, 10000);
}

// Initialize the notifications
async function initNotifications() {
  const customerData = await loadCustomerData();
  const productNames = Object.keys(productImages);

  if (customerData.length > 0) {
    displayDummyNotifications(customerData, productNames);
  }
}

initNotifications();





const style = document.createElement('style');
style.innerHTML = `
  .notification {
    /*display: flex;
    align-items: center;*/
    background: #f4f4f4;
    color: #333;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 0px;;
    font-size: 13px;
    font-family: Arial, sans-serif;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    opacity: 0;
    /*transform: translateX(100%);Initial off-screen right */
    max-width: 300px;
    z-index: 2147483647;
    transition: transform 0.5s ease, opacity 0.5s ease;

    transform: translateX(-100%); /* Off-screen left initially */
    left: 10px; /* Anchor to the left */
    right: auto; /* Remove right positioning */

  }
  .notification img {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-right: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .text-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .customer-info-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .customer-name {
    font-weight: bold;
    font-size: 14px;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .customer-city {
    font-weight: normal;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.7);
  }
  .product-info-line {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
  }
  .time-ago-text {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    font-style: italic;
    align-self: flex-end;
    margin-left: 5px;
  }

  /* Mobile-specific styling */
  @media (max-width: 768px) {
    .notification {
      position: fixed;
      top: 87%;
      right: 0;
      transform: translateX(100%); /* Fully off-screen initially */
      max-width: 200px;
      font-size: 12px;
      transition: transform 0.5s ease, opacity 0.5s ease;
      z-index: 2147483647;
    }
    .notification img {
      width: 30px;
      height: 30px;
    }
  }
`;
document.head.appendChild(style);









